module.exports = __webpack_public_path__ + "front/img/info.b87cb885.png";